import { Component, OnInit } from '@angular/core';
import { RetornoSelecao } from './../../../shared/gridview/RetornoSelecao';
import { Estado } from './../../../shared/shared/estado.enum';

declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-margem-mo',
  templateUrl: './margem-mo.component.html',
  styleUrls: ['./margem-mo.component.css']
})
export class MargemMOComponent implements OnInit {

  selecionado: object;
  state: Estado = Estado.view;

  filtros = {};

  constructor() { }

  ngOnInit() {
  }

  buscar() {
    this.selecionado = undefined;
    this.state = Estado.view;
  }

  selecionar(selecionado: RetornoSelecao) {
    if (selecionado.novoCadastro) {
      this.state = Estado.insert;
    } else {
      this.state = Estado.view;
    }
    this.selecionado = selecionado.registro;
  }

  definirFiltro() {
    $('#margem-mo-filtro').modal();
  }

}
